<template>
  <div class="rounded-top-9 p-2">
    <div class="d-flex align-items-start">
      <img
        style="margin-top: 3px; margin-right: 5px"
        :src="'/assets/icon/call-incoming-v2.svg'" />
      <div class="d-flex flex-column">
        <span class="fw-semibold">Cuộc gọi {{ callType }} {{ callGoing }}</span>
        <span>{{ responseTime(duration) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatCall",
  props: ["duration", "message"],
  methods: {
    responseTime(rpt) {
      let type = " giây";
      if (rpt >= 60 && rpt > 0) {
        rpt = rpt / 60;
        type = " phút";
        if (rpt >= 60) {
          rpt = rpt / 60;
          type = " giờ";
          if (rpt >= 24) {
            rpt = rpt / 24;
            type = " ngày";
            if (rpt >= 365) {
              type = " năm";
              rpt = rpt / 365;
            }
          }
        }
      }

      return rpt.toFixed(2) + type;
    },
  },
  computed: {
    callType() {
      return JSON.parse(JSON.parse(this.message.content).params).calltype ? " video" : " thoại";
    },
    callGoing() {
      try {
        return JSON.parse(JSON.parse(this.message.content).params).isCaller ? " đi" : " đến";
      } catch {
        return "";
      }
    },
    icon() {
      return this.message.id.uidFrom ? " /assets/icon/call-incoming-v2.svg" : " /assets/icon/call-outgoing-v2.svg";
    },
  },
};
</script>

<style scoped>
</style>